import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { analyticsService } from './posthog.service'

function normalizePath(pathname: string): string {
  return pathname
    .replace(/\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '/[id]')
    .replace(/\/\d+/g, '/[id]')
}

export function usePageTracking() {
  const location = useLocation()

  useEffect(() => {
    const normalizedRoute = normalizePath(location.pathname)
    analyticsService.screen(normalizedRoute, {
      route: normalizedRoute,
      source: 'react-router',
      platform: 'web',
    })
  }, [location.pathname])
}
